import { Trans } from '@lingui/react/macro';
import { NoddiIcon, NoddiIconName } from 'noddi-ui-common';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';
import { PropsWithChildren } from 'react';

type Props = {
  isOnTireHotel: boolean;
  upcomingBookingDate?: string | null;
  lastBookingDate?: string | null;
};

/**
 * A car card's muted facts row: tire hotel, then the upcoming booking, else the last one. One row, not badges: badges
 * fought the selected fill and never lined up across cards of different title widths.
 */
export const CarCardMeta = ({ isOnTireHotel, upcomingBookingDate, lastBookingDate }: Props) => {
  if (!isOnTireHotel && !upcomingBookingDate && !lastBookingDate) {
    return null;
  }

  return (
    <div className='flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground'>
      {isOnTireHotel && (
        <MetaItem icon='Warehouse'>
          <Trans>On tire hotel</Trans>
        </MetaItem>
      )}
      {upcomingBookingDate ? (
        <MetaItem icon='Calendar'>
          <Trans>Upcoming booking:</Trans> {noddiFormatDate(upcomingBookingDate, NoddiDateFormats.DATE)}
        </MetaItem>
      ) : (
        lastBookingDate && (
          <MetaItem icon='CheckCircle'>
            <Trans>Last booking:</Trans> {noddiFormatDate(lastBookingDate, NoddiDateFormats.DATE)}
          </MetaItem>
        )
      )}
    </div>
  );
};

const MetaItem = ({ icon, children }: PropsWithChildren<{ icon: NoddiIconName }>) => (
  <span className='flex items-center gap-1'>
    <NoddiIcon name={icon} size='xSmall' />
    <span>{children}</span>
  </span>
);
